import React from "react"
import { GlobalMessageBarItem } from "./MessageBarHooks"

export const MessageBarContext = React.createContext<{
  messages?: Array<GlobalMessageBarItem>
}>({ messages: [] })
